<template>
  <!--
    Фирменный знак Яндекс ID: белая «Я» на красном скруглённом квадрате.

    Инлайн, а не картинкой по ссылке: раньше иконка грузилась с
    `s3.regru.cloud/taste-ok/icon/yandex.svg`, бакет отдал 404 — и логотип пропал у всех
    сразу, без единой ошибки в сборке. Остальные бренд-иконки (MAX, VK, Telegram) по этой
    же причине давно лежат в `shared/ui/icons`.

    Контур буквы — официальный, из ассета Яндекса. Скругление задаётся `rx` подложки:
    10 из 44 — примерно четверть стороны, как у остальных бренд-плашек интерфейса.
  -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    aria-hidden="true"
    class="inline-block shrink-0"
  >
    <rect width="44" height="44" rx="10" fill="#FC3F1D" />
    <path
      d="M24.7407 33.9778H29.0889V9.04443H22.7592C16.3929 9.04443 13.0538 12.303 13.0538 17.1176C13.0538 21.2731 15.2187 23.6163 19.0532 26.1609L21.3832 27.6987L18.3927 25.1907L12.4667 33.9778H17.1818L23.5115 24.5317L21.3098 23.0671C18.6496 21.2731 17.3469 19.8818 17.3469 16.8613C17.3469 14.2068 19.2183 12.4128 22.7776 12.4128H24.7223V33.9778H24.7407Z"
      fill="white"
    />
  </svg>
</template>
